import { z } from 'zod';

export class ActivityFeatures {
  // Open Ended
  public allowEditResponse?: boolean;
  public gradeWordCountByLevel?: boolean;
  public allowApplyGrammarFeedback?: boolean;
  public allowParaphrasing?: boolean;
  public allowReadParagraph?: boolean;

  // Simple Quiz
  public shuffleQuestionGroups?: boolean;
  public shuffleQuestions?: boolean;
  public shuffleChoices?: boolean;
  public skipAnswerDisplay?: boolean;

  constructor(json: unknown) {
    const validateJson = ActivityFeatures.validateJson(json);
    // Open Ended
    this.allowEditResponse = validateJson.allowEditResponse;
    this.gradeWordCountByLevel = validateJson.gradeWordCountByLevel;
    this.allowApplyGrammarFeedback = validateJson.allowApplyGrammarFeedback;
    this.allowParaphrasing = validateJson.allowParaphrasing;
    this.allowReadParagraph = validateJson.allowReadParagraph;

    // Simple Quiz
    this.shuffleQuestionGroups = validateJson.shuffleQuestionGroups;
    this.shuffleQuestions = validateJson.shuffleQuestions;
    this.shuffleChoices = validateJson.shuffleChoices;
    this.skipAnswerDisplay = validateJson.skipAnswerDisplay;
  }

  public static zodSchema = z.object({
    // Open Ended
    allowEditResponse: z.boolean().default(false),
    gradeWordCountByLevel: z.boolean().default(false),
    allowApplyGrammarFeedback: z.boolean().default(false),
    allowParaphrasing: z.boolean().default(false),
    allowReadParagraph: z.boolean().default(false),

    // Simple Quiz
    shuffleQuestionGroups: z.boolean().default(false),
    shuffleQuestions: z.boolean().default(false),
    shuffleChoices: z.boolean().default(false),
    skipAnswerDisplay: z.boolean().default(false),
  });

  public static validateJson(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static validateJsonArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }

  public static fromJson(json: unknown): ActivityFeatures {
    return new ActivityFeatures(json);
  }

  public static fromJsonArray(jsonArray: unknown[]): ActivityFeatures[] {
    return this.validateJsonArray(jsonArray).map(ActivityFeatures.fromJson);
  }
}
